"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UINavItemLabel = _interopRequireDefault(require("../nav/UINavItemLabel"));

var _decorators = require("../utils/propTypes/decorators");

var _componentProp = require("../utils/propTypes/componentProp");

var _times = require("HubStyleTokens/times");

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

var _theme = require("HubStyleTokens/theme");

var _misc = require("HubStyleTokens/misc");

var _Style = require("../core/Style");

var ICON_SIZE = 'xxs';
var NavListItemTransitionWrapper = (0, _styledComponents.default)(_AccordionTransition.default.defaultProps.Wrapper).withConfig({
  displayName: "UINavListItem__NavListItemTransitionWrapper",
  componentId: "ngdu23-0"
})(["margin-left:-", ";padding-left:", ";overflow:", ";"], _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'hidden' : 'visible';
});
var linkStyles = (0, _styledComponents.css)(["display:flex;", ";", ";", ";color:", ";left:-", ";line-height:16px;padding:", " ", " ", " ", ";position:relative;text-decoration:none;width:calc(100% + ", ");cursor:", ";"], (0, _Styles.setFontSmoothing)('auto'), _Styles.FONT_FAMILIES.default, (0, _Styles.setFontSize)(_sizes.BASE_FONT_SIZE), _theme.SIDENAV_FOREGROUND_COLOR, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_Y, _sizes.NAV_ITEM_PADDING_RIGHT, _sizes.NAV_ITEM_PADDING_Y, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled === true ? 'not-allowed' : 'pointer';
});
var activeStyles = (0, _styledComponents.css)(["color:", ";background-color:", ";font-weight:", ";", ";"], _theme.BASE_FONT_COLOR, _theme.SIDENAV_SELECTED_BACKGROUND_COLOR, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, (0, _Styles.setBorderRadius)());
var hoveredStyles = (0, _styledComponents.css)(["", ";color:", ";text-decoration:none;:not(.private-folder-nav-item){background-color:", ";}"], (0, _Styles.setBorderRadius)(), _theme.BASE_FONT_COLOR, _theme.SIDENAV_HOVERED_BACKGROUND_COLOR);
var parentStyles = (0, _styledComponents.css)(["user-select:none;"]);
var StyledLink = (0, _styledComponents.default)(function (props) {
  var Link = props.linkComponent,
      __active = props.active,
      __hasChildren = props.hasChildren,
      __hovered = props.hovered,
      __responsive = props.responsive,
      rest = (0, _objectWithoutProperties2.default)(props, ["linkComponent", "active", "hasChildren", "hovered", "responsive"]);
  return _react.default.createElement(Link, rest);
}).withConfig({
  displayName: "UINavListItem__StyledLink",
  componentId: "ngdu23-1"
})(["", " ", " &&{", ";}", " &.private-nav-item--active{", ";}&:focus{z-index:", ";}.private-tag--unenclosed{line-height:16px;}&& > .private-help-icon{display:inline-flex;}&& > .private-icon:not(.private-icon-circle__inner):not(:first-child),&& > .private-help-icon:not(:first-child) .private-icon{margin-left:", ";margin-right:0;}"], linkStyles, function (_ref3) {
  var active = _ref3.active;
  return active ? activeStyles : undefined;
}, function (_ref4) {
  var hovered = _ref4.hovered,
      disabled = _ref4.disabled;
  return hovered && !disabled ? hoveredStyles : undefined;
}, function (_ref5) {
  var hasChildren = _ref5.hasChildren;
  return hasChildren ? parentStyles : undefined;
}, activeStyles, _sizes.MERCURY_LAYER, (0, _Style.emCalc)(_sizes.BASE_ICON_SPACING_X));
var Icon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "UINavListItem__Icon",
  componentId: "ngdu23-2"
})(["margin-right:", ";"], function (_ref6) {
  var placement = _ref6.placement;
  return placement === 'right' && '0 !important';
});
var NavItemLabel = (0, _styledComponents.default)(_UINavItemLabel.default).withConfig({
  displayName: "UINavListItem__NavItemLabel",
  componentId: "ngdu23-3"
})(["flex-grow:1;"]);

var UINavListItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UINavListItem, _Component);

  function UINavListItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UINavListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UINavListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onOpenChange = _this$props.onOpenChange,
          open = _this$props.open;
      if (onClick) onClick(evt);

      if (!evt.defaultPrevented) {
        onOpenChange((0, _SyntheticEvent.default)(!open));
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UINavListItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          active = _this$props2.active,
          children = _this$props2.children,
          className = _this$props2.className,
          count = _this$props2.count,
          duration = _this$props2.duration,
          __hovered = _this$props2.hovered,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          itemClassName = _this$props2.itemClassName,
          linkComponent = _this$props2.linkComponent,
          __onBlur = _this$props2.onBlur,
          __onClick = _this$props2.onClick,
          __onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          _rootRenderer = _this$props2._rootRenderer,
          title = _this$props2.title,
          __value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["active", "children", "className", "count", "duration", "hovered", "iconLeft", "iconRight", "itemClassName", "linkComponent", "onBlur", "onClick", "onOpenChange", "open", "_rootRenderer", "title", "value"]);

      var renderIcon = function renderIcon(icon, placement) {
        if (!icon) return null;

        if (_react.default.isValidElement(icon)) {
          return icon;
        }

        if (typeof icon === 'function') {
          return icon({
            children: children,
            open: open,
            size: ICON_SIZE,
            placement: placement
          });
        }

        return _react.default.createElement(Icon, {
          name: icon,
          size: ICON_SIZE,
          placement: placement,
          color: placement === 'right' ? _theme.BASE_LINK_COLOR : _colors.CALYPSO
        });
      };

      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        var hovered = hoverProviderProps.hovered,
            hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
        var classes = (0, _classnames.default)(className, 'private-nav-item', {
          'private-nav-item--active': active
        });
        return _react.default.createElement("li", {
          className: itemClassName
        }, _react.default.createElement(StyledLink, Object.assign({
          active: active,
          hasChildren: (0, _componentProp.isRenderable)(children),
          hovered: hovered || undefined,
          linkComponent: linkComponent
        }, rest, hoverProviderRestProps, {
          "aria-current": active ? 'true' : null,
          className: classes,
          onClick: _this2.handleClick
        }), renderIcon(iconLeft, 'left'), _react.default.createElement(NavItemLabel, {
          count: count
        }, title), renderIcon(iconRight, 'right')), _react.default.createElement(_AccordionTransition.default, {
          open: open,
          duration: duration,
          Wrapper: NavListItemTransitionWrapper
        }, (0, _componentProp.isRenderable)(children) && _rootRenderer && _rootRenderer(children)));
      });
    }
  }]);
  return UINavListItem;
}(_react.Component);

UINavListItem.propTypes = {
  active: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  count: _propTypes.default.node,
  external: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  duration: _propTypes.default.number,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  iconLeft: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  iconRight: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  itemClassName: _propTypes.default.string,
  linkComponent: _propTypes.default.elementType,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  title: _propTypes.default.node.isRequired,
  value: _propTypes.default.node,
  _rootRenderer: _propTypes.default.func
};
UINavListItem.defaultProps = {
  active: false,
  external: false,
  disabled: false,
  duration: parseInt(_times.NAV_LIST_TRANSITION_ANIMATION_TIMING, 10),
  linkComponent: _UILink.default,
  open: false
};
UINavListItem.displayName = 'UINavListItem';

var _default = (0, _Controllable.default)(UINavListItem, ['open']);

exports.default = _default;
module.exports = exports.default;